export const validation = {
  name: 'required|min:5|max:50',
  description: 'min:3'
}

export const TypeFields = function () {
  return {
    name: null,
    description: null
  }
}

export const texts = {
  galleryTypeEdit: {
    title: 'Editar Tipo de Galería Existente',
    subtitle: 'Edita la información del tipo de  galería',
    submit: 'Actualizar Tipo',
    messages: {
      success: {
        title: 'TIPO ACTUALIZADO',
        text: 'Este tipo de galería ha sido actualizado correctamente'
      }
    }
  },
  galleryTypeNew: {
    title: 'Añadir Nuevo tipo de Galería',
    subtitle: 'Crear nuevos tipos de galería para el sitio web, crea galerías, agrupalas por tipo.',
    submit: 'Crear Tipo',
    messages: {
      success: {
        title: 'TIPO CREADO',
        text: 'Se ha creado correctamente el nuevo tipo de galería'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/galleries/type.mocks.js